<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import NavigationInnerHead from 'components/User/NavigationInnerHead.vue';
import { FavouriteStore } from 'stores/Favourite/Favourite.ts';
import { storeToRefs } from 'pinia';
import ProductListItem from 'components/Product/List/ProductListItem.vue';
import { useQuasar } from 'quasar';

export default defineComponent({
  name: 'Favourite',
  components: { ProductListItem, NavigationInnerHead },

  setup() {
    const $q = useQuasar();
    const favouriteStore = FavouriteStore();
    const { favourites, favouriteLoading, listParams } = storeToRefs(favouriteStore);

    favouriteStore.favouriteList();

    const removeLoading = ref({});

    const pagination = ref({
      current: 1,
      limit: computed(() => Math.floor(favourites.value.count / listParams.value.limit)),
    });

    return {
      favourites,
      favouriteLoading,
      removeLoading,
      pagination,
      favouriteRemove: (productCode: number) => {
        if (removeLoading.value[productCode]) return;
        removeLoading.value[productCode] = true;
        favouriteStore
          .favouriteRemove(productCode)
          .then(({ status, message }) => {
            if (status._200_) {
              $q.notify({
                color: 'green',
                icon: 'fa-regular fa-circle-check',
                message: 'Ürün favorilerden kaldırılmıştır',
                badgeColor: 'white',
                badgeTextColor: 'green-10',
              });
            } else {
              $q.notify({
                color: 'red',
                icon: 'fa-solid fa-circle-exclamation',
                message,
              });
            }
            removeLoading.value[productCode] = false;
          })
          .catch(() => {
            removeLoading.value[productCode] = false;
          });
      },
      changePagination() {
        listParams.value.start = (pagination.value.current - 1) * listParams.value.limit;
        favouriteStore.favouriteList();
      },
    };
  },
});
</script>

<template>
  <q-card class="bg-transparent shadow-0">
    <div class="flex justify-between items-center q-mb-md">
      <div>
        <navigation-inner-head title="Favorilerim" icon="favorite" />
      </div>
      <div></div>
    </div>
    <q-separator color="accent" />
    <div class="row column">
      <div v-if="favouriteLoading" class="col-12 q-pa-sm">
        <div style="width: 100%" class="text-center">
          <q-linear-progress color="primary" indeterminate class="q-mb-lg" />
          <span class="text-h6 text-weight-bold">Favorileriniz Yükleniyor</span>
        </div>
      </div>
      <div v-else class="row q-py-lg">
        <div v-if="!favourites.noData" class="col-12">
          <q-list style="min-width: 100%">
            <product-list-item :key="productKey" v-for="(product, productKey) in favourites.list" :product="product" clickable>
              <template v-slot:append>
                <q-item-section avatar>
                  <div class="flex justify-end">
                    <q-btn flat round :href="`/${product.link}`" target="_blank">
                      <q-icon name="fa-solid fa-arrow-up-right-from-square" size="1rem" />
                      <q-tooltip class="text-body2 text-weight-bold bg-primary">Ürüne Git</q-tooltip>
                    </q-btn>
                    <q-btn flat icon="delete" color="red" round @click.stop="favouriteRemove(product.code)" :loading="removeLoading[product.code]">
                      <q-tooltip class="text-body2 text-weight-bold bg-primary">Favorilerimden Çıkar</q-tooltip>
                    </q-btn>
                  </div>
                </q-item-section>
              </template>
            </product-list-item>
          </q-list>
        </div>
        <div v-else class="col-12">
          <q-banner inline-actions rounded class="bg-accent">
            <div class="flex items-center text-body1 text-weight-medium">
              <q-icon name="info" size="1.3rem" left />
              Favori listenizde ürün bulunmuyor
            </div>
          </q-banner>
        </div>
      </div>
      <div v-if="favourites.list.length > 0" class="col-12 flex justify-center">
        <q-pagination v-model="pagination.current" :max="pagination.limit" input @update:model-value="changePagination" />
      </div>
    </div>
  </q-card>
</template>

<style scoped></style>
